import get from 'lodash/get';
import errorObj from 'aurora-utils/error';
import { workflowIds, applicationTypes } from 'aurora-utils/constants';
import * as types from './constants';

const initialState = {
  loading: false,
  error: null,
  workflowId: workflowIds.SELL_PURCHASE,
  applicationType: applicationTypes.SELL_PURCHASE,
  workflow: {},
  currentStep: 0,
  form: {
    buyers: [],
    sellers: [],
    saleDetails: {},
    valuationValue: 0,
    calculateFee: {},
    isAppDocsRequired: false,
    totalSellingPercentage: 0,
    totalBuyingPercentage: 0,
  },
  appointmentDetails: {},
  appoimentLocations: [],
  appointmentWorkingHours: '',
  emrtsLookup: [],
  applicationId: null,
  application: {},
  documents: [],
  validations: null,
  property: null,
  applicationNumber: null,
  errorObj,
  isCalcultaeFee: false,

  // ------------ revamp --------------//
  buyers: [],
  sellers: [],
  owners: [],
  allSharesIncluded: false,
  buyerAttendees: [],
  sellerAttendees: [],
  chooseTimeslot: {},
  attendeesListBuyer: {},
  attendeesListSeller: {},
  selectedTimeslot: null,
  breakdown: {},
};

export default function sellPurchaseReducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.SELL_AND_PURCHASE_LOADING:
      return {
        ...state,
        loading: true,
      };
    case types.SELL_AND_PURCHASE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case types.SELL_AND_PURCHASE_ERROR:
      return {
        ...state,
        loading: false,
        error: get(action.payload, 'error', null),
      };
    case types.SELL_AND_PURCHASE_CLEAR_ERROR:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.SELL_AND_PURCHASE_CLEAR_REDUCER:
      return initialState;

    case types.SELL_AND_PURCHASE_INITIATE_APPLICATION:
      return {
        ...state,
        loading: false,
        workflow: get(action.payload, 'workflow.result'),
        applicationId: get(action.payload, 'application.result.id'),
        applicationNumber: get(action.payload, 'application.result.applicationNumber'),
        application: get(action.payload, 'application.result'),
        property: get(action.payload, 'property'),
      };

    case types.SELL_AND_PURCHASE_FETCH_APPLICATION_DETAILS:
      return {
        ...state,
        loading: false,
        error: null,
        application: get(action.payload, 'application'),
        applicationId: get(action.payload, 'applicationId'),
        applicationNumber: get(action.payload, 'applicationNumber'),
        form: {
          ...state.form,
          saleDetails: get(action.payload, 'form.saleDetails'),
          valuationValue: get(action.payload, 'form.valuationValue'),
        },
        applicationDetails: get(action.payload, 'application.result.applicationDetails'),
        appoimentLocations: get(action.payload, 'appoimentLocations'),
        emrtsLookup: action.payload.emrtsLookup,
        sellers: get(action.payload, 'sellers', []),
        owners: get(action.payload, 'owners', []),
        allSharesIncluded: get(action.payload, 'allSharesIncluded', false),
        buyers: get(action.payload, 'buyers', []),
        appointmentDetails: get(action.payload, 'appointmentDetails'),
        chooseTimeslot: get(action.payload, 'chooseTimeslot'),
      };

    case types.SELL_AND_PURCHASE_FETCH_PROPERTY:
      return {
        ...state,
        loading: false,
        property: get(action.payload, 'property', state?.property),
      };

    case types.SELL_AND_PURCHASE_SAVE_UPDATED_OWNERS:
      const isAllSharesIncluded = get(action.payload, 'allSharesIncluded', state?.allSharesIncluded);
      const updatedOwnersData = (action?.payload?.owners || state?.owners || [])?.map(owner => {
        const curOwnerData = state?.owners?.find(curOwner => curOwner?.id === owner?.id);
        if (isAllSharesIncluded !== true && curOwnerData?.seller && curOwnerData !== undefined) {
          return {
            ...owner,
            transactionShare: curOwnerData?.transactionShare,
          };
        }

        return owner;
      });
      return {
        ...state,
        loading: false,
        owners: updatedOwnersData,
        sellers: get(action.payload, 'sellers', state?.sellers),
        allSharesIncluded: isAllSharesIncluded,
        documents: get(action.payload, 'documents', state?.documents),
      };
    case types.SELL_AND_PURCHASE_SAVE_UPDATED_BUYERS:
      return {
        ...state,
        loading: false,
        buyers: get(action.payload, 'buyers', state?.buyers),
        documents: get(action.payload, 'documents', state?.documents),
      };
    case types.SELL_AND_PURCHASE_CHANGE_BUYER_TRANSACTION_SHARE:
      const buyersAfterTransactionChange = state.buyers?.map(buyer => {
        if (buyer?.id === action?.payload?.id) {
          return {
            ...buyer,
            transactionShare: action?.payload?.transactionShare,
          };
        }
        return buyer;
      });
      return {
        ...state,
        buyers: buyersAfterTransactionChange,
      };
    case types.SELL_AND_PURCHASE_CHANGE_OWNER_TRANSACTION_SHARE:
      const ownersAfterTransactionChange = state.owners?.map(owner => {
        if (owner?.id === action?.payload?.id) {
          return {
            ...owner,
            transactionShare: action?.payload?.transactionShare,
          };
        }
        return owner;
      });
      return {
        ...state,
        owners: ownersAfterTransactionChange,
      };
    case types.SELL_AND_PURCHASE_FETCH_DOCUMENTS:
      return {
        ...state,
        loading: false,
        documents: get(action.payload, 'documents', state?.documents),
      };
    case types.SELL_PURCHASE_FETCH_BREAKDOWN:
      return {
        ...state,
        loading: false,
        breakdown: get(action.payload, 'breakdown', state?.breakdown),
      };

    // ------------------ previous work -------------------- //
    case types.GENERAL_SP_ERROR:
      return {
        ...state,
        loading: false,
        error: get(action.payload, 'error', 'oops_something_went_wrong'),
      };
    case types.INITIATE_SP_APPLICATION:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_SP_WORKFLOW:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_SP_WORKFLOW_SUCCESS:
      return {
        ...state,
        loading: false,
        workflow: get(action.payload, 'workflow.result'),
      };
    case types.CHANGE_SP_WORKFLOW_STEP:
      return {
        ...state,
        currentStep: action.payload,
      };
    case types.FETCH_VALIDATION:
      return {
        ...state,
        query: get(action.payload, 'query'),
        loading: true,
      };
    case types.FETCH_VALIDATION_SUCCESS:
      return {
        ...state,
        loading: false,
        validations: get(action.payload, 'validations') || null,
        property: get(action.payload, 'property') || null,
        errorObj,
      };
    case types.CHANGE_FORM:
      return {
        ...state,
        form: get(action.payload, 'data'),
      };
    case types.CHANGE_PERCENTAGE:
      return {
        ...state,
        form: {
          ...state.form,
          ...action.payload,
        },
      };
    case types.CHANGE_SELLING_DETAIL:
      return {
        ...state,
        form: {
          ...state.form,
          saleDetails: get(action.payload, 'form.saleDetails') || null,
        },
      };
    case types.CHANGE_APPOINMENT_DETAIL:
      return {
        ...state,
        appointmentDetails: get(action.payload, 'appointmentDetails') || null,
      };
    case types.UPDATE_ATTENDES_LIST_BUYER:
      return {
        ...state,
        attendeesListBuyer: get(action.payload, 'attendeesListBuyer') || null,
      };
    case types.UPDATE_ATTENDES_LIST_SELLER:
      return {
        ...state,
        attendeesListSeller: get(action.payload, 'attendeesListSeller') || null,
      };
    case types.UPDATED_TIME_SLOT:
      return {
        ...state,
        selectedTimeslot: get(action.payload, 'selectedTimeslot') || null,
      };
    case types.UPDATE_WORKING_HOURS:
      return {
        ...state,
        appointmentWorkingHours: get(action.payload, 'appointmentWorkingHours') || null,
      };
    case types.ADD_BROKER_SUCCESS:
      return {
        ...state,
        loading: false,
        form: {
          ...state.form,
          saleDetails: get(action.payload, 'form.saleDetails'),
        },
      };
    case types.DELETE_BROKER_SUCCESS:
      return {
        ...state,
        loading: false,
        form: {
          ...state.form,
          saleDetails: get(action.payload, 'form.saleDetails'),
        },
      };

    case types.CALCULATE_FEE_SUCCESS:
      return {
        ...state,
        loading: false,
        form: {
          ...state.form,
          calculateFee: get(action.payload, 'form.calculateFee') || null,
        },
      };
    case types.SAVE_APPOINMET_DETAIL:
      return {
        ...state,
        loading: false,
        appointmentDetails: get(action.payload, 'appointmentDetails'),
      };
    case types.SAVE_SALE_DETAIL:
      return {
        ...state,
        loading: false,
        form: {
          ...state.form,
          saleDetails: get(action.payload, 'form.saleDetails'),
        },
      };
    case types.FETCH_BUYER:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_BUYER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.RESET_BUYER_RESPONSE:
      return {
        ...state,
        form: {
          ...state.form,
          buyerResponse: null,
        },
      };
    case types.ADD_BUYER:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.ADD_BUYER_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
        form: {
          ...state.form,
          buyers: get(action.payload, 'buyers', []),
        },
      };
    }
    case types.DOWNLOAD_DOCUMENT:
      return {
        ...state,
        loading: true,
      };
    case types.DOWNLOAD_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case types.DELETE_BUYER:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DELETE_BUYER_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
        form: {
          ...state.form,
          buyers: get(action.payload, 'buyers', []),
        },
        documents: get(action.payload, 'newDocuments.result', []),
      };
    }
    case types.ADD_TO_ERROR_INITITATE:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case types.ADD_TO_ERROR:
      return {
        ...state,
        loading: false,
        error: get(action.payload, 'message'),
      };
    case types.FETCH_EVALUATION:
      return {
        ...state,
        loading: true,
      };
    case types.FETCH_EVALUATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        form: {
          ...state.form,
          evaluationAmount: get(action.payload, 'evaluation.result.valuationValue'),
          evaluationFee: get(action.payload, 'evaluationFee', 0),
          transactionFeePercent: get(action.payload, 'evaluation.result.transactionFeePercent'),
        },
      };
    case types.SAVE_APPLICATION:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.SAVE_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        currentStep: get(action.payload, 'step'),
      };
    case types.FETCH_OWNERS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.CHECKOUT_SALE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case types.FETCH_OWNERS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        form: {
          ...state.form,
          sellers: get(action.payload, 'newSellers'),
        },
      };
    case types.FETCH_SP_POA:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_SP_POA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.ADD_SP_POA:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.ADD_SP_POA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        application: get(action.payload, 'application.result.application', null),
        documents: get(action.payload, 'documents.result', []),
      };
    case types.DELETE_SP_POA:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DELETE_SP_POA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        application: get(action.payload, 'application.result.application', null),
      };
    case types.UPLOAD_DOCUMENT:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.UPLOAD_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.UPLOAD_SP_DOCUMENT:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.UPLOAD_SP_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        documents: get(action.payload, 'documents', []),
      };
    case types.DELETE_DOCUMENT:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DELETE_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.FETCH_APPLICATION_DETAILS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_APPLICATION_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        application: get(action.payload, 'application'),
        documents: get(action.payload, 'documents', []),
        property: get(action.payload, 'property'),
        applicationId: get(action.payload, 'applicationId'),
        applicationNumber: get(action.payload, 'applicationNumber'),
        form: {
          ...state.form,
          saleDetails: get(action.payload, 'form.saleDetails'),
          valuationValue: get(action.payload, 'form.valuationValue'),
        },
        applicationDetails: get(action.payload, 'application.result.applicationDetails'),
        appoimentLocations: get(action.payload, 'appoimentLocations'),
        emrtsLookup: action.payload.emrtsLookup,
        sellers: get(action.payload, 'sellers', []),
        owners: get(action.payload, 'owners', []),
        allSharesIncluded: get(action.payload, 'allSharesIncluded', false),
        buyers: get(action.payload, 'buyers', []),
        appointmentDetails: get(action.payload, 'appointmentDetails'),
      };
    case types.FETCH_AUDITOR_FLOW_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        application: get(action.payload, 'application'),
        documents: get(action.payload, 'documents', []),
        property: get(action.payload, 'property'),
        applicationId: get(action.payload, 'applicationId'),
        applicationNumber: get(action.payload, 'applicationNumber'),
        form: {
          ...state.form,
          saleDetails: get(action.payload, 'form.saleDetails'),
          valuationValue: get(action.payload, 'form.valuationValue'),
        },
        applicationDetails: get(action.payload, 'application.result.applicationDetails'),
        appoimentLocations: get(action.payload, 'appoimentLocations'),
        emrtsLookup: action.payload.emrtsLookup,
        sellers: get(action.payload, 'sellers', []),
        owners: get(action.payload, 'owners', []),
        allSharesIncluded: get(action.payload, 'allSharesIncluded', false),
        buyers: get(action.payload, 'buyers', []),
        appointmentDetails: get(action.payload, 'appointmentDetails'),
        buyerAttendees: get(action.payload, 'buyerAttendees'),
        sellerAttendees: get(action.payload, 'sellerAttendees'),
        chooseTimeslot: get(action.payload, 'chooseTimeslot'),
      };
    case types.SUBMIT_APPLICATION:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.SUBMIT_APPLICATION_SUCCESS:
      return {
        ...initialState,
        loading: false,
      };
    case types.RESET_SELL_AND_PURCHASE_WORKFLOW:
      return {
        ...initialState,
      };
    case types.DISCARD_SELL_AND_PURCHASE_APPLIATION:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DISCARD_SELL_AND_PURCHASE_APPLIATION_SUCCESS:
      return {
        ...initialState,
      };
    case types.IS_SALE_VALUE_UPDATE:
      return {
        ...state,
        isCalcultaeFee: action.payload.isCalcultaeFee,
      };
    default:
      return state;
  }
}
